import { useState } from 'react';

function useSessionStorage(key, initialValue) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = sessionStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error("Error accessing sessionStorage:", error);
            return initialValue;
        }
    });

    const setValue = (value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            sessionStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error("Error setting sessionStorage:", error);
        }
    };

    return [storedValue, setValue];
}

// Additional function to directly access sessionStorage value
export function getSessionValueDirectly(key, initialValue = null) {
    try {
        const item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
    } catch (error) {
        console.error("Error accessing sessionStorage:", error);
        return initialValue;
    }
}

export default useSessionStorage;
